import { compose, head, prop } from 'ramda';
import { createSelector } from 'reselect';

import { campaignViews, NAME } from './constants';

const getRoot = prop(NAME);

export const getFullSort = compose(prop('sort'), getRoot);
export const getSort = compose(head, getFullSort);
export const getCurrentCampaigns = compose(prop(campaignViews.CURRENT_CAMPAIGNS), getRoot);
export const getPlanedCampaigns = compose(prop(campaignViews.PLANED_CAMPAIGNS), getRoot);

export const getCampaignById = createSelector(
	getCurrentCampaigns,
	(state, campaignId) => Number(campaignId),
	(campaigns, campaignId) => campaigns.find((campaign) => campaign.id === campaignId),
);
